import { inject, Injectable } from "@angular/core";
import { APP_ROUTES_TOKEN, ConfigService } from "@web-client/shared";
import { NavigationEnd, Router } from "@angular/router";
import { BehaviorSubject, filter, map, Observable } from "rxjs";
import { NavGroup } from "../components/navigation/nav-links.component";

@Injectable({
    providedIn: 'root'
})
export class MenuItemService {
    private readonly APP_ROUTES = inject(APP_ROUTES_TOKEN);
    private readonly router = inject(Router);
    private readonly config = inject(ConfigService);
    getSelectedMenuItems(): Observable<NavGroup[]> {
        return this.selectedCategory$.pipe(
            map(category => {
                if (!category) return this.desktopMenuItems;
                return this.desktopMenuItems.filter(x => x.category === category);
            })
        )
    }
    activeMenuItem(category: string | null) {
        this.selectedCategory$.next(category);
    }

    getMenuCategories(): string[] {
        return this.desktopMenuItems.map(x => x.category)
    }
    mobileMenuItems: NavGroup[] = [];
    desktopMenuItems: NavGroup[] = [];

    public selectedCategory$ = new BehaviorSubject<string | null>(null);

    constructor() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.selectedCategory$.next(null);
        });

        const productionOnly = this.config.productionOnly;

        this.mobileMenuItems = this.APP_ROUTES.map(route => {
            const grouped = (route.children || []).reduce((acc, child) => {
                const cat = child.category || 'Other';
                if (!acc[cat]) acc[cat] = [];
                // hide coming soon items
                if (child.comingSoon) return acc;
                // hide non-production items
                if (productionOnly && !child.production) return acc;

                acc[cat].push({
                    label: child.title,
                    path: child.path
                });
                return acc;
            }, {} as Record<string, { label: string, path: string }[]>);

            return {
                category: route.title,
                // hide empty groups
                subGroups: Object.entries(grouped).filter(x => x[1].length > 0).map(([label, links]) => ({
                    label: label === 'Other' ? undefined : label,
                    links
                }))
            };
        }).filter(x => x.subGroups.length > 0);

        // hide empty groups
        this.desktopMenuItems = this.mobileMenuItems.filter(x => x.subGroups.length > 0);
    }
}
